(ns superadmin.agency-table.view
  (:require ["@mui/material/Button$default" :as Button]
            ["@mui/material/Stack$default" :as Stack]
            ["@mui/x-data-grid-premium" :refer [DataGridPremium useGridApiContext GridActionsCellItem]]
            ["src/svg/inform/plus.svg$default" :as Plus]
            [common.queries :refer [use-query]]
            [common.resource.query.agency :as agency.q]
            [common.widgets.data-grid :as dg]
            [re-frame.core :as rf]
            [reitit.frontend.easy :as r.easy]
            [uix.core :as uix :refer [$ defui]]))

(def ^:private columns
  #js [#js {:field "name"
            :headerName "Name"
            :type "string"
            :minWidth 250
            :flex 3
            :valueGetter (fn [_value row ^js _column ^js _apiRef]
                           (:name row))}
       #js {:field "id"
            :headerName "ID"
            :type "number"
            :minWidth 100
            :flex 1
            :headerAlign "right"
            :align "right"
            :valueGetter (fn [_value row ^js _column ^js _apiRef]
                           (:id row))}
       #js {:field "tenant"
            :headerName "Tenant"
            :type "string"
            :minWidth 200
            :flex 1
            :headerAlign "right"
            :align "right"
            :valueGetter (fn [_value row ^js _column ^js _apiRef]
                           (or (-> row :tenantInfo :name) (-> row :tenantInfo :id)))}
       #js {:field "user-count"
            :headerName "# Users"
            :type "number"
            :minWidth 100
            :flex 1
            :headerAlign "right"
            :align "right"
            :valueGetter (fn [_value row ^js _column ^js _apiRef]
                           (:user-count row))}
       #js {:field "advertiser-count"
            :headerName "# Advertisers"
            :type "number"
            :minWidth 100
            :flex 1
            :headerAlign "right"
            :align "right"
            :valueGetter (fn [_value row ^js _column ^js _apiRef]
                           (:advertiser-count row))}
       #js {:field "campaign-count"
            :headerName "# Campaigns"
            :type "number"
            :minWidth 100
            :flex 1
            :headerAlign "right"
            :align "right"
            :valueGetter (fn [_value row ^js _column ^js _apiRef]
                           (:campaign-count row))}

       #js {:field "actions"
            :headerName "Actions"
            :type "actions"
            :align "right"
            :minWidth 80
            :getActions (fn [^js params]
                          #js [($ GridActionsCellItem
                                  {:onClick (fn [_]
                                              (rf/dispatch [:ocp/open {:id :agency/crud
                                                                       :props (.-row params)}]))
                                   :label "Edit Tenant"
                                   :showInMenu true})])}])

(def Toolbar
  (uix/as-react
   (fn []
     (let [api (-> (useGridApiContext) .-current)
           handle-export #(.. api (exportDataAsCsv %))]
       ($ dg/grid-toolbar
          ($ Stack {:direction "row" :gap 1}
             ($ Button
                {:onClick #(handle-export #js {})
                 :data-test-id :export-metrics-button
                 :variant "outlined"}
                "Export metrics")
             ($ Button
                {:onClick #(rf/dispatch [:ocp/open {:id :agency/crud}])
                 :variant "contained"
                 :startIcon ($ Plus)
                 :data-test-id :create-agency-button}
                "New agency")))))))

(defn- get-row-id [row]
  (:id row))

(defui agency-data-grid []
  (let [{:keys [data isPending]} (use-query (agency.q/superadmin-agencies-query))

        page-size 10

        initial-state (uix/use-memo
                       (fn []
                         #js {:sorting #js {:sortModel #js [#js {:field "updated-at" :sort "desc"}]}
                              :pagination #js {:paginationModel #js {:pageSize page-size}}})
                       [page-size])]
    ($ DataGridPremium
       {:columns columns
        :loading isPending

        :rows (to-array data)
        :getRowId get-row-id

        :disableRowSelectionOnClick true

        :pagination true
        :pageSizeOptions #js [page-size]

        :initialState initial-state

        :slots #js {:cell dg/WithLinkCell
                    :toolbar Toolbar}
        :slotProps #js {:baseTextField dg/grid-toolbar-outlined-input
                        :cell #js {:href-fn (fn [row]
                                              (r.easy/href :agency/advertiser-management {:agency-id (:id row)}))}}

        :data-testid "table-agency"

        :noWrap true
        :sx #js {:maxHeight "70rem"}})))
